var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 146,
    viewBox: "0 0 194 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13148_15041)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.60791,
    width: 193.167,
    height: 145,
    rx: 10,
    fill: "#1E2631"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 12.6079,
    width: 186,
    height: 24,
    rx: 12,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 44.6079,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7296 60.8862L34.4852 55.9059C34.3326 55.294 33.7826 54.865 33.1514 54.865H16.3501C15.719 54.865 15.169 55.294 15.015 55.9059L13.7706 60.8862C13.7569 60.9398 13.75 60.9962 13.75 61.0525C13.75 62.9473 15.2144 64.4901 17.0157 64.4901C18.062 64.4901 18.9957 63.9689 19.5938 63.1604C20.1919 63.9689 21.1256 64.4901 22.172 64.4901C23.2183 64.4901 24.152 63.9689 24.7501 63.1604C25.3482 63.9689 26.2805 64.4901 27.3283 64.4901C28.376 64.4901 29.3083 63.9689 29.9064 63.1604C30.5045 63.9689 31.4368 64.4901 32.4845 64.4901C34.2858 64.4901 35.7502 62.9473 35.7502 61.0525C35.7502 60.9962 35.7433 60.9398 35.7296 60.8862Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4845 66.1007C31.5482 66.1007 30.6585 65.8147 29.9064 65.2922C28.4021 66.3386 26.2544 66.3386 24.7501 65.2922C23.2458 66.3386 21.0981 66.3386 19.5938 65.2922C18.8417 65.8147 17.952 66.1007 17.0156 66.1007C16.3405 66.1007 15.7039 65.9426 15.125 65.6731V72.9758C15.125 73.7348 15.741 74.3508 16.5 74.3508H22.0001V68.8508H27.5001V74.3508H33.0002C33.7592 74.3508 34.3752 73.7348 34.3752 72.9758V65.6731C33.7963 65.9426 33.1597 66.1007 32.4845 66.1007Z",
    fill: "#FFDBA5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 44.6079,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2296 60.8862L82.9852 55.9059C82.8326 55.294 82.2826 54.865 81.6514 54.865H64.8501C64.219 54.865 63.669 55.294 63.515 55.9059L62.2706 60.8862C62.2569 60.9398 62.25 60.9962 62.25 61.0525C62.25 62.9473 63.7144 64.4901 65.5157 64.4901C66.562 64.4901 67.4957 63.9689 68.0938 63.1604C68.6919 63.9689 69.6256 64.4901 70.672 64.4901C71.7183 64.4901 72.652 63.9689 73.2501 63.1604C73.8482 63.9689 74.7805 64.4901 75.8283 64.4901C76.876 64.4901 77.8083 63.9689 78.4064 63.1604C79.0045 63.9689 79.9368 64.4901 80.9845 64.4901C82.7858 64.4901 84.2502 62.9473 84.2502 61.0525C84.2502 60.9962 84.2433 60.9398 84.2296 60.8862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9845 66.1007C80.0482 66.1007 79.1585 65.8147 78.4064 65.2922C76.9021 66.3386 74.7544 66.3386 73.2501 65.2922C71.7458 66.3386 69.5981 66.3386 68.0938 65.2922C67.3417 65.8147 66.452 66.1007 65.5156 66.1007C64.8405 66.1007 64.2039 65.9426 63.625 65.6731V72.9758C63.625 73.7348 64.241 74.3508 65 74.3508H70.5001V68.8508H76.0001V74.3508H81.5002C82.2592 74.3508 82.8752 73.7348 82.8752 72.9758V65.6731C82.2963 65.9426 81.6597 66.1007 80.9845 66.1007Z",
    fill: "#B2B6BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 44.6079,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.73 60.8862L131.485 55.9059C131.333 55.294 130.783 54.865 130.151 54.865H113.35C112.719 54.865 112.169 55.294 112.015 55.9059L110.771 60.8862C110.757 60.9398 110.75 60.9962 110.75 61.0525C110.75 62.9473 112.214 64.4901 114.016 64.4901C115.062 64.4901 115.996 63.9689 116.594 63.1604C117.192 63.9689 118.126 64.4901 119.172 64.4901C120.218 64.4901 121.152 63.9689 121.75 63.1604C122.348 63.9689 123.28 64.4901 124.328 64.4901C125.376 64.4901 126.308 63.9689 126.906 63.1604C127.505 63.9689 128.437 64.4901 129.485 64.4901C131.286 64.4901 132.75 62.9473 132.75 61.0525C132.75 60.9962 132.743 60.9398 132.73 60.8862Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.485 66.1007C128.548 66.1007 127.659 65.8147 126.906 65.2922C125.402 66.3386 123.254 66.3386 121.75 65.2922C120.246 66.3386 118.098 66.3386 116.594 65.2922C115.842 65.8147 114.952 66.1007 114.016 66.1007C113.341 66.1007 112.704 65.9426 112.125 65.6731V72.9758C112.125 73.7348 112.741 74.3508 113.5 74.3508H119V68.8508H124.5V74.3508H130C130.759 74.3508 131.375 73.7348 131.375 72.9758V65.6731C130.796 65.9426 130.16 66.1007 129.485 66.1007Z",
    fill: "#FFDBA5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 44.6079,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.23 60.8862L179.985 55.9059C179.833 55.294 179.283 54.865 178.651 54.865H161.85C161.219 54.865 160.669 55.294 160.515 55.9059L159.271 60.8862C159.257 60.9398 159.25 60.9962 159.25 61.0525C159.25 62.9473 160.714 64.4901 162.516 64.4901C163.562 64.4901 164.496 63.9689 165.094 63.1604C165.692 63.9689 166.626 64.4901 167.672 64.4901C168.718 64.4901 169.652 63.9689 170.25 63.1604C170.848 63.9689 171.78 64.4901 172.828 64.4901C173.876 64.4901 174.808 63.9689 175.406 63.1604C176.005 63.9689 176.937 64.4901 177.985 64.4901C179.786 64.4901 181.25 62.9473 181.25 61.0525C181.25 60.9962 181.243 60.9398 181.23 60.8862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.985 66.1007C177.048 66.1007 176.159 65.8147 175.406 65.2922C173.902 66.3386 171.754 66.3386 170.25 65.2922C168.746 66.3386 166.598 66.3386 165.094 65.2922C164.342 65.8147 163.452 66.1007 162.516 66.1007C161.841 66.1007 161.204 65.9426 160.625 65.6731V72.9758C160.625 73.7348 161.241 74.3508 162 74.3508H167.5V68.8508H173V74.3508H178.5C179.259 74.3508 179.875 73.7348 179.875 72.9758V65.6731C179.296 65.9426 178.66 66.1007 177.985 66.1007Z",
    fill: "#B2B6BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 92.6079,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7296 108.886L34.4852 103.906C34.3326 103.294 33.7826 102.865 33.1514 102.865H16.3501C15.719 102.865 15.169 103.294 15.015 103.906L13.7706 108.886C13.7569 108.94 13.75 108.996 13.75 109.053C13.75 110.947 15.2144 112.49 17.0157 112.49C18.062 112.49 18.9957 111.969 19.5938 111.16C20.1919 111.969 21.1256 112.49 22.172 112.49C23.2183 112.49 24.152 111.969 24.7501 111.16C25.3482 111.969 26.2805 112.49 27.3283 112.49C28.376 112.49 29.3083 111.969 29.9064 111.16C30.5045 111.969 31.4368 112.49 32.4845 112.49C34.2858 112.49 35.7502 110.947 35.7502 109.053C35.7502 108.996 35.7433 108.94 35.7296 108.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4845 114.101C31.5482 114.101 30.6585 113.815 29.9064 113.292C28.4021 114.339 26.2544 114.339 24.7501 113.292C23.2458 114.339 21.0981 114.339 19.5938 113.292C18.8417 113.815 17.952 114.101 17.0156 114.101C16.3405 114.101 15.7039 113.943 15.125 113.673V120.976C15.125 121.735 15.741 122.351 16.5 122.351H22.0001V116.851H27.5001V122.351H33.0002C33.7592 122.351 34.3752 121.735 34.3752 120.976V113.673C33.7963 113.943 33.1597 114.101 32.4845 114.101Z",
    fill: "#B2B6BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 92.6079,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2296 108.886L82.9852 103.906C82.8326 103.294 82.2826 102.865 81.6514 102.865H64.8501C64.219 102.865 63.669 103.294 63.515 103.906L62.2706 108.886C62.2569 108.94 62.25 108.996 62.25 109.053C62.25 110.947 63.7144 112.49 65.5157 112.49C66.562 112.49 67.4957 111.969 68.0938 111.16C68.6919 111.969 69.6256 112.49 70.672 112.49C71.7183 112.49 72.652 111.969 73.2501 111.16C73.8482 111.969 74.7805 112.49 75.8283 112.49C76.876 112.49 77.8083 111.969 78.4064 111.16C79.0045 111.969 79.9368 112.49 80.9845 112.49C82.7858 112.49 84.2502 110.947 84.2502 109.053C84.2502 108.996 84.2433 108.94 84.2296 108.886Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9845 114.101C80.0482 114.101 79.1585 113.815 78.4064 113.292C76.9021 114.339 74.7544 114.339 73.2501 113.292C71.7458 114.339 69.5981 114.339 68.0938 113.292C67.3417 113.815 66.452 114.101 65.5156 114.101C64.8405 114.101 64.2039 113.943 63.625 113.673V120.976C63.625 121.735 64.241 122.351 65 122.351H70.5001V116.851H76.0001V122.351H81.5002C82.2592 122.351 82.8752 121.735 82.8752 120.976V113.673C82.2963 113.943 81.6597 114.101 80.9845 114.101Z",
    fill: "#FFDBA5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 92.6079,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.73 108.886L131.485 103.906C131.333 103.294 130.783 102.865 130.151 102.865H113.35C112.719 102.865 112.169 103.294 112.015 103.906L110.771 108.886C110.757 108.94 110.75 108.996 110.75 109.053C110.75 110.947 112.214 112.49 114.016 112.49C115.062 112.49 115.996 111.969 116.594 111.16C117.192 111.969 118.126 112.49 119.172 112.49C120.218 112.49 121.152 111.969 121.75 111.16C122.348 111.969 123.28 112.49 124.328 112.49C125.376 112.49 126.308 111.969 126.906 111.16C127.505 111.969 128.437 112.49 129.485 112.49C131.286 112.49 132.75 110.947 132.75 109.053C132.75 108.996 132.743 108.94 132.73 108.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.485 114.101C128.548 114.101 127.659 113.815 126.906 113.292C125.402 114.339 123.254 114.339 121.75 113.292C120.246 114.339 118.098 114.339 116.594 113.292C115.842 113.815 114.952 114.101 114.016 114.101C113.341 114.101 112.704 113.943 112.125 113.673V120.976C112.125 121.735 112.741 122.351 113.5 122.351H119V116.851H124.5V122.351H130C130.759 122.351 131.375 121.735 131.375 120.976V113.673C130.796 113.943 130.16 114.101 129.485 114.101Z",
    fill: "#B2B6BC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 92.6079,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.23 108.886L179.985 103.906C179.833 103.294 179.283 102.865 178.651 102.865H161.85C161.219 102.865 160.669 103.294 160.515 103.906L159.271 108.886C159.257 108.94 159.25 108.996 159.25 109.053C159.25 110.947 160.714 112.49 162.516 112.49C163.562 112.49 164.496 111.969 165.094 111.16C165.692 111.969 166.626 112.49 167.672 112.49C168.718 112.49 169.652 111.969 170.25 111.16C170.848 111.969 171.78 112.49 172.828 112.49C173.876 112.49 174.808 111.969 175.406 111.16C176.005 111.969 176.937 112.49 177.985 112.49C179.786 112.49 181.25 110.947 181.25 109.053C181.25 108.996 181.243 108.94 181.23 108.886Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.985 114.101C177.048 114.101 176.159 113.815 175.406 113.292C173.902 114.339 171.754 114.339 170.25 113.292C168.746 114.339 166.598 114.339 165.094 113.292C164.342 113.815 163.452 114.101 162.516 114.101C161.841 114.101 161.204 113.943 160.625 113.673V120.976C160.625 121.735 161.241 122.351 162 122.351H167.5V116.851H173V122.351H178.5C179.259 122.351 179.875 121.735 179.875 120.976V113.673C179.296 113.943 178.66 114.101 177.985 114.101Z",
    fill: "#FFDBA5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 140.608,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 140.608,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 140.608,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 140.608,
    width: 40.5,
    height: 40,
    rx: 6,
    fill: "#363E4A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13148_15041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.217 100L129 80.8261L129.913 79H132.196L141.783 82.1957L150 86.7609V88.587L146.348 91.7826L142.696 94.9783L140.413 99.5435L137.217 100Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.279 89.6207L147.061 89.7366C143.908 91.488 140.474 95.3015 138.897 98.8029L138.792 99.0445C138.197 100.367 137.653 100.607 137.481 100.599C137.309 100.59 136.786 100.311 136.291 98.938L130.121 81.7974C129.872 81.1066 129.789 80.5613 129.798 80.2245C129.806 79.8882 129.872 79.8014 129.911 79.759C129.949 79.7156 130.027 79.6422 130.331 79.6328C130.634 79.6239 131.125 79.7156 131.747 79.9923L147.183 86.8436C148.419 87.3934 148.67 87.9733 148.678 88.1641C148.686 88.3559 148.47 88.9595 147.279 89.6207ZM148.057 84.398L132.629 77.5466C131.793 77.1743 131.008 76.9795 130.261 77.0017C129.514 77.0254 128.768 77.3005 128.232 77.8947C127.697 78.4888 127.45 79.3172 127.428 80.1471C127.408 80.9769 127.584 81.8482 127.919 82.7767L134.089 99.9084C134.762 101.776 135.872 103.159 137.385 103.229C138.897 103.298 140.097 102.027 140.907 100.229L141.021 99.9769C142.254 97.2378 145.652 93.4643 148.118 92.0955L148.346 91.9692C149.964 91.0699 151.11 89.7375 151.046 88.0576C150.984 86.3782 149.738 85.145 148.057 84.398Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13148_15041",
    x: 123.427,
    y: 77,
    width: 31.6221,
    height: 34.2314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13148_15041"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13148_15041",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13148_15041"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.60791,
    width: 193.167,
    height: 145,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreGrid);
export default __webpack_public_path__ + "static/media/StoreGrid.75a5b88978cb59b7643d009aac2cfe1c.svg";
export { ForwardRef as ReactComponent };